<template>
  <component :is="layout">
    <slot/>
    <LoginModal
        v-if="loginFormState.showLoginModal"
        :isVisible="loginFormState.showLoginModal"
        :initialTab="currentTab"
    />
    <CookieConsent/>
  </component>
</template>

<script lang="ts">
import AppLayoutDefault from '@/layouts/AppLayoutDefault.vue'
import { defineComponent, onBeforeMount, watch } from "vue";
import authStore from "@/store/auth.ts"
import LoginModal from "@/components/modals/LoginModal/LoginModal.vue";
import { useRoute } from "vue-router";
import CookieConsent from "@/components/CookieConsent.vue"; // Добавляем импорт

export default defineComponent({
  name: "AppLayout",
  components: {
    LoginModal,
    CookieConsent // Регистрируем компонент
  },
  data: () => ({
    layout: AppLayoutDefault
  }),
  setup() {
    const { loginFormState, openLoginModal } = authStore;
    const route = useRoute();

    watch(() => route.query, (newQuery) => {
      if (newQuery.slm === 'true') {
        openLoginModal(
            typeof newQuery.tab === 'string' ? newQuery.tab : 'login'
        );
      }
    });

    onBeforeMount(() => authStore.fetchUserData());

    return {
      loginFormState,
      currentTab: loginFormState.tab
    };
  },
  watch: {
    $route: {
      immediate: true,
      async handler(route) {
        this.layout = route.meta.layout || AppLayoutDefault;
      }
    }
  }
});
</script>
